import React from 'react'
import { isMobile } from 'react-device-detect'
import { Link } from 'react-router-dom'
import { faKey, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCDangerColor,
  $DCDangerLightColor,
  $DCInfoColor,
  $DCInfoLightColor,
  $DCprimaryColor,
  $DCSuccessColor,
  $DCSuccessLightColor,
  $DCWarningColor,
  $DCWarningLightColor,
  DcBreadcrumbs,
  DcButton,
  DcDiv,
  DcFlexBox,
  DcIcon,
  DcOverlaySlider,
  DcTag,
  DcText,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  Section,
  SectionContent,
} from 'pixel-base'
import { get } from 'utils/api-routes.util'
import CheckIcon from 'utils/icons/check-icon'
import XmarkIcon from 'utils/icons/xmark-icon'

import ReAuthenticate from './components/ReAuthenticate'
import StoreLogos from './components/StoreLogos'
import StoreDetail from './StoreDetail'

const StoresComponent = () => {
  const [storeList, setStoreList] = React.useState([])
  const [autModal, setAutModal] = React.useState(false)
  const [storeId, setStoreId] = React.useState(null)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [currentStore, setCurrentStore] = React.useState({
    name: '',
    url: '',
    type: '',
    id: '',
  })

  const getStoreslist = () => {
    setTableLoading(true)
    get('/tenant/stores').subscribe((res: any) => {
      setStoreList(res.response.data)
      setTableLoading(false)
    })
  }

  const [tableLoading, setTableLoading] = React.useState(true)

  const onRowClicked = (row) => {
    // navigate(`/admin/store/${row?.store_id}`)
    setStoreId(row.store_id)
    setShowDetailModal(true)
  }
  const columns = [
    {
      dataKey: 'store_id',
      name: 'Store',
      selector: (row) => <StoreLogos store_type={row.store_type} />,
    },
    {
      dataKey: 'store_name',
      name: 'Store Name',
      sortable: true,
      selector: (row) =>
        row.store_name == 'PixelOne' ? 'DotCom' : row.store_name || '--',
    },
    {
      dataKey: 'host_url',
      name: 'Store URL',
      sortable: true,
      selector: (row) =>
        row.host_url ? (
          <a href={row.host_url} target="_blank" rel="noreferrer">
            {row.host_url}
          </a>
        ) : (
          '--'
        ),
    },
    {
      dataKey: 'incoming_sync',
      name: 'Incoming Sync',
      sortable: true,
      selector: (row) =>
        row.incoming_sync ? (
          <CheckIcon color="green" size={16} />
        ) : (
          <XmarkIcon color="red" size={16} />
        ),
    },
    {
      dataKey: 'outgoing_sync',
      name: 'Outgoing Sync',
      sortable: true,
      selector: (row) =>
        row.outcoming_sync ? (
          <CheckIcon color="green" size={16} />
        ) : (
          <XmarkIcon color="red" size={16} />
        ),
    },

    {
      dataKey: 'store_status',
      name: 'Status',
      sortable: true,
      selector: (row) =>
        row.store_status === 'ready' ? (
          <DcTag
            textColor={$DCSuccessColor}
            customBackgroundColor={$DCSuccessLightColor}
            className="success"
          >
            Ready
          </DcTag>
        ) : row.store_status === 'sync' ? (
          <DcTag
            textColor={$DCInfoColor}
            customBackgroundColor={$DCInfoLightColor}
          >
            Sync
          </DcTag>
        ) : row.store_status === 'pending' ? (
          <DcTag
            textColor={$DCWarningColor}
            customBackgroundColor={$DCWarningLightColor}
          >
            Pending
          </DcTag>
        ) : row.store_status === 'failed' ? (
          <>
            <DcTag
              textColor={$DCDangerColor}
              customBackgroundColor={$DCDangerLightColor}
            >
              Failed
            </DcTag>
          </>
        ) : (
          '--'
        ),
    },
    {
      dataKey: 're_authenticate',
      name: 'Re Authenticate',
      selector: (row) => <PixelTableAction row={row} action={actions} />,
    },
  ]

  const actions = [
    {
      title: 'Re Authenticate',
      icon: (
        <Section>
          <PixelIcon icon={faKey} />
        </Section>
      ),
      disabled: (row) => {
        return row['store_status'] !== 'failed'
      },
      clickHandler: (row) => {
        setCurrentStore({
          name: row.store_name,
          url: row.host_url,
          type: row.store_type,
          id: row.store_id,
        })
        row['store_status'] === 'failed' && setAutModal(true)
      },
    },
  ]

  React.useEffect(() => {
    getStoreslist()
  }, [])
  const breadcrumbs = [
    {
      name: 'Settings',
      active: false,
    },
    {
      name: 'Linked Stores',
      active: true,
    },
  ]
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0 ' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              justifyContent="flex-end"
              padding=" 5px 20px"
              height="auto"
            >
              <Link to="/admin/stores/new">
                <DcButton size="sm">
                  <PixelIcon color="white" icon={faPlus} /> Add{' '}
                  {!isMobile && 'Stores'}
                </DcButton>
              </Link>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }} isMobile={isMobile}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={storeList}
              highlightOnHover={true}
              pointerOnHover={true}
              onRowClicked={onRowClicked}
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      {autModal && (
        <DcOverlaySlider
          isOpen={autModal}
          onClose={() => setAutModal(false)}
          title={'Re Authenticate Your Store'}
          padding="0px"
          width="40%"
        >
          {autModal && <ReAuthenticate currentStore={currentStore} />}
        </DcOverlaySlider>
      )}

      <DcOverlaySlider
        isOpen={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        title="Store Details"
        padding="0px"
      >
        <StoreDetail
          storeId={storeId}
          setShowDetailModal={setShowDetailModal}
        />
      </DcOverlaySlider>
    </>
  )
}

export default StoresComponent
